<template>
  <div>
    <label v-if="!loading" class="checkbox-control-form">
      <input
        class="cursor-pointer"
        @click.prevent="onChange"
        :value="value"
        v-model="items"
        type="checkbox"
      />
      <span class="checkmark"></span>
    </label>

    <v-progress-circular
      v-else
      size="20"
      width="3"
      indeterminate
    ></v-progress-circular>
  </div>
</template>

<script>
export default {
  name: "role-checkbox",
  props: {
    value: {},
    items: {
      type: Array,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    setLoading(val) {
      this.loading = val;
    },
    onChange() {
      const value = !this.items.includes(this.value);
      this.$emit("change", {
        value,
        role: this.value,
      });
    },
  },
};
</script>
